module.exports = __webpack_public_path__ + "h5/img/banner_2020.e73a55cd.jpg";